/** True when a daily timing set has a usable window (used for goals API + MaxDayVsSlots pickers). */
export function isDailyTimingSetConfigured(setData: any): boolean {
  if (!setData || !setData.timeSlot || !setData.timeSlot.length) {
    return false;
  }
  const slot = setData.timeSlot[0];
  if (!slot || slot.fromTime == null || slot.toTime == null) {
    return false;
  }
  const from = String(slot.fromTime).trim();
  const to = String(slot.toTime).trim();
  return from.length > 0 && to.length > 0;
}
